// extracted by mini-css-extract-plugin
export var image = "logo-slider-module--image--UGwPx";
export var slide = "logo-slider-module--slide--laeb9";
export var slider = "logo-slider-module--slider--X4vEj";